import script from "./DeferredTax.vue?vue&type=script&setup=true&lang=js"
export * from "./DeferredTax.vue?vue&type=script&setup=true&lang=js"

import "./DeferredTax.vue?vue&type=style&index=0&id=fd95ed90&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-fd95ed90"]])

export default __exports__